import React from 'react';
import { Box, Typography } from '@mui/material';

const primarySx = {
  fontSize: '0.875rem',
  fontWeight: 700,
  color: 'text.primary',
  lineHeight: 1.4,
  display: 'block',
};

const meetingLinkLabelSx = {
  fontSize: '0.8125rem',
  fontWeight: 600,
  color: 'text.secondary',
  lineHeight: 1.4,
  display: 'block',
  mt: 1,
};

const meetingLinkSx = {
  fontSize: '0.875rem',
  fontWeight: 500,
  color: '#1565C0',
  lineHeight: 1.4,
  textDecoration: 'underline',
  wordBreak: 'break-all',
  display: 'inline-block',
  mt: 0.5,
  '&:hover': {
    color: 'info.dark',
  },
};

const OnlineEventLocationDisplay = ({ meetingLink, dense = false }) => {
  const link = String(meetingLink ?? '').trim();

  return (
    <Box>
      <Typography sx={primarySx}>Online event</Typography>
      <Typography sx={{ ...meetingLinkLabelSx, mt: dense ? 0.75 : 1 }}>Meeting Link</Typography>
      {link ? (
        <Typography
          component="a"
          href={link}
          target="_blank"
          rel="noopener noreferrer"
          sx={meetingLinkSx}
        >
          {link}
        </Typography>
      ) : (
        <Typography sx={{ fontSize: '0.875rem', color: 'text.primary', mt: 0.5 }}>—</Typography>
      )}
    </Box>
  );
};

export default OnlineEventLocationDisplay;
